export default "__VITE_ASSET__9567aea3__"